import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 20h18l-9 -16z","key":"svg-0"}]]

const IconBrandZeit = createReactComponent('outline', 'brand-zeit', 'BrandZeit', __iconNode);

export default IconBrandZeit;